const ReferralActionType = {
  GET_REFERRAL: 'GET_REFERRAL',
  SAVE_REFERRAL: 'SAVE_REFERRAL',
  RESET_REFERRAL: 'RESET_REFERRAL',

  GET_REFERRAL_REFEREES: 'GET_REFERRAL_REFEREES',
  SAVE_REFERRAL_REFEREES: 'SAVE_REFERRAL_REFEREES',
  RESET_REFERRAL_REFEREES: 'RESET_REFERRAL_REFEREES',

  GET_PLAYER_REFERRAL_REFEREES: 'GET_PLAYER_REFERRAL_REFEREES',
  SAVE_PLAYER_REFERRAL_REFEREES: 'SAVE_PLAYER_REFERRAL_REFEREES',
  RESET_PLAYER_REFERRAL_REFEREES: 'RESET_PLAYER_REFERRAL_REFEREES',

  GET_PLAYER_REFERRALS: 'GET_PLAYER_REFERRALS',
  SAVE_PLAYER_REFERRALS: 'SAVE_PLAYER_REFERRALS',
  RESET_PLAYER_REFERRALS: 'RESET_PLAYER_REFERRALS',

  GET_REFERRAL_COMMISSION_PERIODS: 'GET_REFERRAL_COMMISSION_PERIODS',

  SAVE_PLAYER_REFERRAL_PERIODS: 'SAVE_PLAYER_REFERRAL_PERIODS',
  RESET_PLAYER_REFERRAL_PERIODS: 'RESET_PLAYER_REFERRAL_PERIODS',

  SAVE_REFERRAL_ACCUMULATED_PERIODS: 'SAVE_REFERRAL_ACCUMULATED_PERIODS',

  SAVE_REFERRAL_TRANSFERRED_PERIODS: 'SAVE_REFERRAL_TRANSFERRED_PERIODS',

  SAVE_REFERRAL_FAILED_PERIODS: 'SAVE_REFERRAL_FAILED_PERIODS',
};

export default ReferralActionType;
